export default "/images/8a8d04dab9fdea047bafde777f1077d6.avif";